import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { generateAxiosInstanceInstitute } from '../hooks/useAuthorizedRequestForInstitute';
import { generateAxiosInstanceSection } from '../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceCommon } from '../hooks/useAuthorizedReuestCommon';
import { useNavigate } from 'react-router-dom';
import { GeneratePdf } from '../components/GeneratePdf';
import { Loader } from '../components/ModalsCommonFunctions';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import Pagination from '../components/Pagination';

const StudentCredentials = () => {
    const authorizedAxios = generateAxiosInstance();
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute();
    const authorizedAxiosSection = generateAxiosInstanceSection();
    const authorizedAxiosCommon = generateAxiosInstanceCommon();
    const initialForm = {
        instituteMasterId: '',
        sectionMasterId: '',
        year: "",
        gradeId: "",
        divisionId: ""
    }
    const [instituteList, setInstituteList] = useState([]);
    const [sectionList, setSectionList] = useState([]);
    const [credentials, setCredentials] = useState("");
    const [showPassword, setShowPassword] = useState([]);
    const [divisionList, setDivisionList] = useState([]);
    const [gradeList, setGradeList] = useState([]);
    const [yearList, setYearList] = useState([]);
    const [studentData, setStudentData] = useState(initialForm);


    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);
    const [refresh, setRefresh] = useState(true);
    const [addNew, setAddNew] = useState(false);

    const [studentNameSort, setStudentNameSort] = useState(null);
    const [emailSort, setEmailSort] = useState(null);
    const [genderSort, setGenderSort] = useState(null);
    const [userIdSort, setUserIdSort] = useState(null);
    const [academicYearSort, setAcademicYearSort] = useState(null);
    const [classSort, setClassSort] = useState(null);
    const [divisionSort, setDivisionSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["student.studentName", "student.email", "student.gender", "userId"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getInstituteList();
    }, []);

    useEffect(() => {
        getCredentials();
    }, [studentData]);

    const getInstituteList = () => {
        const apiUrlForInstituteList = `/get-institute-master`;
        authorizedAxios && authorizedAxios.get(apiUrlForInstituteList)
            .then(response => {
                setInstituteList(response.data.result);
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            })
    }

    const getApiUrl = () => {
        let apiUrl = `/get-students-details?instituteMasterId=${studentData.instituteMasterId}&sectionMasterId=${studentData.sectionMasterId}&`;
        if (studentData.year !== '') {
            apiUrl += `year=${studentData.year}&`;
        }
        if (studentData.gradeId !== '') {
            apiUrl += `gradeId=${studentData.gradeId}&`;
        }
        if (studentData.divisionId !== '') {
            apiUrl += `divisionId=${studentData.divisionId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            setRefresh(!refresh);
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (studentData.instituteMasterId.length !== 0 && studentData.sectionMasterId.length !== 0) {
                setCurrPage(1);
                setCredentials(await searchArray("B", getApiUrl(), searchKeys, searchValue.trim()));
            }
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(credentials, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId, addNew])

    useEffect(() => {
        setTotalPages(Math.ceil(credentials.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > credentials.length) {
            endIndex = credentials.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(credentials.slice(startIndex, endIndex));
    }, [credentials, currPage, itemsPerPage]);

    const handleInsituteChange = (e) => {
        const { name, value } = e.target;
        setStudentData(prevData => {
            return {
                ...prevData,
                sectionMasterId: '',
                year: '',
                gradeId: '',
                divisionId: '',
                [name]: value
            }
        })

        setYearList([]);
        setGradeList([]);
        setDivisionList([]);

        const apiUrl = `/get-section?instituteMasterId=${value}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setSectionList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSectionChange = (e) => {
        const { name, value } = e.target;
        setStudentData((prevData) => {
            return {
                ...prevData,
                year: '',
                gradeId: '',
                divisionId: '',
                [name]: value
            }
        })

        setGradeList([]);
        setDivisionList([]);

        const apiUrl1 = `/sections-academic-years?sectionMasterId=${value}`;
        authorizedAxiosCommon && authorizedAxiosCommon.get(apiUrl1)
            .then(response => {
                setYearList(response.data.data)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleYearChange = (e) => {
        const { name, value } = e.target;
        setStudentData((prevData) => {
            return {
                ...prevData,
                gradeId: '',
                divisionId: '',
                [name]: value
            }
        })

        setDivisionList([]);

        const apiUrl = `/get-institute-grade?instituteMasterId=${studentData.instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setGradeList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getCredentials = () => {
        if (studentData.instituteMasterId.length !== 0 && studentData.sectionMasterId.length !== 0) {
            authorizedAxiosSection && authorizedAxiosSection.get(getApiUrl())
                .then(response => {
                    setCredentials(response.data.result);
                })
                .catch(error => {
                    setCredentials([]);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    }

    const handleGradeChange = (e) => {
        const { name, value } = e.target;
        setStudentData((prevData) => {
            return {
                ...prevData,
                [name]: value,
                divisionId: ''
            }
        })
        const apiUrlForSyllabus = `/grade-wise-division?instituteMasterId=${studentData.instituteMasterId}&instituteGradeMasterId=${value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrlForSyllabus)
            .then(response => {
                setDivisionList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        setStudentData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const togglePasswordVisibility = (index) => {
        setShowPassword(prevState => {
            const updatedShowPassword = [...prevState];
            updatedShowPassword[index] = !updatedShowPassword[index];
            return updatedShowPassword;
        });
    };

    const sendMail = (email, userId, password) => {
        setLoading(true);
        const data = {
            email: email,
            userId: userId,
            password: password
        };

        const apiUrl = `/send-credential-to-mail`;
        authorizedAxiosCommon && authorizedAxiosCommon.post(apiUrl, data)
            .then(response => {
                setTimeout(() => {
                    Swal.fire({ text: response.data.message });
                }, 100);
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            })
            .finally(() => {
                setLoading(false); // End loading
            });
    }

    const handleInputReset = () => {
        setStudentData(initialForm);
        setSectionList([]);
        setYearList([]);
        setGradeList([]);
        setDivisionList([]);
    }



    useEffect(() => {
        if (studentNameSort == true || studentNameSort == false) {
            setUserIdSort(null);
            setEmailSort(null);
            setGenderSort(null);
            setDivisionSort(null);
            setAcademicYearSort(null);
            setClassSort(null);
        }
    }, [studentNameSort])

    useEffect(() => {
        if (userIdSort == true || userIdSort == false) {
            setStudentNameSort(null);
            setEmailSort(null);
            setGenderSort(null);
            setDivisionSort(null);
            setAcademicYearSort(null);
            setClassSort(null);
        }
    }, [userIdSort])

    useEffect(() => {
        if (emailSort == true || emailSort == false) {
            setStudentNameSort(null);
            setUserIdSort(null);
            setGenderSort(null);
            setDivisionSort(null);
            setAcademicYearSort(null);
            setClassSort(null);
        }
    }, [emailSort])

    useEffect(() => {
        if (genderSort == true || genderSort == false) {
            setEmailSort(null);
            setStudentNameSort(null);
            setUserIdSort(null);
            setDivisionSort(null);
            setAcademicYearSort(null);
            setClassSort(null);
        }
    }, [genderSort])

    useEffect(() => {
        if (divisionSort == true || divisionSort == false) {
            setEmailSort(null);
            setStudentNameSort(null);
            setUserIdSort(null);
            setGenderSort(null);
            setAcademicYearSort(null);
            setClassSort(null);
        }
    }, [divisionSort])

    useEffect(() => {
        if (academicYearSort == true || academicYearSort == false) {
            setEmailSort(null);
            setStudentNameSort(null);
            setUserIdSort(null);
            setGenderSort(null);
            setDivisionSort(null);
            setClassSort(null);
        }
    }, [academicYearSort])

    useEffect(() => {
        if (classSort == true || classSort == false) {
            setEmailSort(null);
            setStudentNameSort(null);
            setUserIdSort(null);
            setGenderSort(null);
            setDivisionSort(null);
            setAcademicYearSort(null);
        }
    }, [classSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Student Credentials</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fas fa-key"></i>Student Credentials</b></h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="instituteMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Institute</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteMasterId' onChange={handleInsituteChange} value={studentData.instituteMasterId} >
                                                        <option selected value={''} disabled>Select Institute</option>
                                                        {
                                                            instituteList?.map((institute) => {
                                                                return <option value={institute.id}>{institute.instituteName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="sectionMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Section</label>
                                                    <select class="form-select" aria-label="Default select example" name='sectionMasterId' onChange={handleSectionChange} value={studentData.sectionMasterId} >
                                                        <option selected value={''} disabled>Select Section</option>
                                                        {
                                                            sectionList?.map((section) => {
                                                                return <option value={section.id}>{section.sectionName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Year :</label>
                                                    <select class="form-select" aria-label="Default select example" name='year' onChange={handleYearChange} value={studentData.year}>
                                                        <option selected value={''} disabled>Select Year</option>
                                                        {
                                                            yearList?.map((year) => {
                                                                return <option value={year.academicYearMasterId}>{year.academicYearMasterDetails.yearName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Class :</label>
                                                    <select class="form-select" aria-label="Default select example" name='gradeId' onChange={handleGradeChange} value={studentData.gradeId}>
                                                        <option selected value={''} disabled>Select Class</option>
                                                        {
                                                            gradeList?.map((grade) => {
                                                                return <option value={grade.id}>{grade.gradeName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Division :</label>
                                                    <select class="form-select" aria-label="Default select example" name='divisionId' onChange={handleInputChange} value={studentData.divisionId}>
                                                        <option selected value={''} disabled>Select Division</option>
                                                        {
                                                            divisionList?.map((division) => {
                                                                return <option value={division.id}>{division.divisionName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                <div className="col-auto">
                                                    <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={handleInputReset}>Reset</button>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        {displayedData.length > 0 && <GeneratePdf id="studentCredentitals" title={displayedData} headerTitle={"Student Credentials"} />}
                                                        <div className='search_btn_row'/* style={{ flexWrap: 'nowrap' }}*/>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div id="studentCredentitals">
                                                            <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col" className='sl_no'>Sr. No.</th>
                                                                            <th scope="col">
                                                                                Student Name
                                                                                <SortIcon sortState={studentNameSort} setSortState={setStudentNameSort} setData={setCredentials} setCurrPage={setCurrPage} sortingPath={"student.studentName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Email
                                                                                <SortIcon sortState={emailSort} setSortState={setEmailSort} setData={setCredentials} setCurrPage={setCurrPage} sortingPath={"student.email"} />
                                                                            </th>
                                                                            <th scope="col">Contact Number</th>
                                                                            <th scope="col">
                                                                                Gender
                                                                                <SortIcon sortState={genderSort} setSortState={setGenderSort} setData={setCredentials} setCurrPage={setCurrPage} sortingPath={"student.gender"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Academic Year
                                                                                <SortIcon sortState={academicYearSort} setSortState={setAcademicYearSort} setData={setCredentials} setCurrPage={setCurrPage} sortingPath={"student.academicYearMasterDetails.yearName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Class
                                                                                <SortIcon sortState={classSort} setSortState={setClassSort} setData={setCredentials} setCurrPage={setCurrPage} sortingPath={"student.instituteGradeMasterDetails.gradeName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Division
                                                                                <SortIcon sortState={divisionSort} setSortState={setDivisionSort} setData={setCredentials} setCurrPage={setCurrPage} sortingPath={"student.instituteDivisionMasterDetails.divisionName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                User Id
                                                                                <SortIcon sortState={userIdSort} setSortState={setUserIdSort} setData={setCredentials} setCurrPage={setCurrPage} sortingPath={"userId"} />
                                                                            </th>
                                                                            <th scope="col">Password</th>
                                                                            <th scope='col'>Send Mail</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            displayedData?.length > 0 ?
                                                                                displayedData?.map((cred, index) => {
                                                                                    return (
                                                                                        <tr>
                                                                                            <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                            <td>{cred.student.studentName}</td>
                                                                                            <td>{cred.student.email}</td>
                                                                                            <td>{cred.student.primaryContact}, {cred.student.secondaryContact}</td>
                                                                                            <td>{cred.student.gender}</td>
                                                                                            <td>{cred.student.academicYearMasterDetails.yearName}</td>
                                                                                            <td>{cred.student.instituteGradeMasterDetails.gradeName}</td>
                                                                                            <td>{cred.student.instituteDivisionMasterDetails.divisionName}</td>
                                                                                            <td>{cred.userId}</td>
                                                                                            <td>
                                                                                                {showPassword[index] ? (cred.password) : ('••••••••')}
                                                                                                <button
                                                                                                    className="btn btn-link"
                                                                                                    type="button"
                                                                                                    onClick={() => togglePasswordVisibility(index)}
                                                                                                >
                                                                                                    <i className={`fa ${showPassword[index] ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                                                                                </button>
                                                                                            </td>
                                                                                            <td>
                                                                                                <button className="btn btn-outline-info" type="button" onClick={() => sendMail(cred.student.email, cred.userId, cred.password)}>
                                                                                                    <i className="fa fa-paper-plane"></i>
                                                                                                </button>
                                                                                            </td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                :
                                                                                (<tr>
                                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Credentials Available</th>
                                                                                </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                                <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={credentials.length} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default StudentCredentials;
